/**
 * The published terms and privacy policy: where each one is, in the reader's language.
 *
 * The documents are published by the Docs Site at `/<language>/legal/<document>/`. This class is the
 * only place that knows that shape, so moving the publisher is one change here.
 */
export class Legal {
	static DOCUMENTS = ['privacy', 'terms'] as const;

	#origin?: string;

	/**
	 * @param origin The publisher's origin; absent while nothing is published
	 */
	constructor(origin?: string) {
		this.#origin = origin?.replace(/\/$/, '') || undefined;
	}

	/** Whether there is anything to link to */
	get published(): boolean {
		return Boolean(this.#origin);
	}

	/**
	 * @returns The address of a document in a language, or undefined while nothing is published
	 */
	address(document: (typeof Legal.DOCUMENTS)[number], language: string): string | undefined {
		if (!this.#origin) return undefined;
		const code = language === 'es' ? 'es' : 'en';
		return `${this.#origin}/${code}/legal/${document}/`;
	}
}
